<template>
  <accordion-simple-item title="Projekte" :flex="true">
    <div class="flex flex-grow flex-col overflow-hidden h-full">
      <TRInput v-model="projectSearch" type="text" placeholder="Projekt suchen..."
               class="p-2 w-full my-2"></TRInput>
      <div class="overflow-auto ">
        <div v-for="project in filteredProjects" :key="project.projectId" class=" cursor-pointer w-full ">
          <div class="w-full p-1  flex my-2 " @click="showMagazines(project.projectId)" :key="project.projectId" :data-ui="'sidebar-project' + project.name"
               :class="{ 'bg-trader-blue text-white': projectId == project.projectId, 'bg-trader-dark-gray': projectId != project.projectId }">
            <span class="w-full  h-full"> {{ project.name }}</span>
          </div>
          <div v-if="selectedProjectId === project.projectId && selectedMagazines">
            <div v-for="magazine in selectedMagazines" :key="magazine.magazineId">
              <div class="p-1 ml-4"  :class="{ 'bg-trader-blue text-white': magazineId == magazine.magazineId }">
                  <span :data-ui="'sidebar-magazine'+ magazine.name"
                      @click="navigateTo(`/administration/${accordionIndex}/page` , { project: project.projectId , magazine: magazine.magazineId, pagePosition: 1, marktId: 0})"
                      class="hover:underline">{{ magazine.name }}
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </accordion-simple-item>
</template>

<script>
import TRInput from "@/components/Base/TRInput.vue";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {
  name: "SPurchaser",
  data() {
    return {
      projectSearch: "",
      selectedProjectId: null,
      selectedMagazines: null,
      projectId: 0,
      magazineId: 0,
      projectData: {projects: []},
    }
  },
  props: {
    getProjectId: {
      type: Function,
      default: () => {
      }
    },
    accordionIndex: {
      type: Number,
      default: () => {
      }
    },
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  computed: {
    ...mapState('user', ['userData']),
    filteredProjects() {
      return this.projectData.projects.filter(project => project.name.toLowerCase().includes(this.projectSearch.toLowerCase()));
    },
  },
  methods: {
    async getProjects() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query GetProjectDetails {
              projects {
                projectId
                name
                magazines {
                  magazineId
                  name
                  numberOfPages
                }
              }
            }
          `
        });
        this.projectData = response.data;
      } catch (error) {
        console.error("Fehler beim Abrufen der Projektdaten:", error);
      }
    },
    showMagazines(projectId) {
      this.getProjectId(projectId);
      // Wenn die projectId bereits ausgewählt ist, setzen Sie die Auswahl zurück
      if (this.selectedProjectId === projectId) {
        this.selectedMagazines = null;
        this.selectedProjectId = null;
        return;
      }
      const selectedProject = this.projectData.projects.find(project => project.projectId === projectId);
      if (selectedProject) {
        this.selectedMagazines = selectedProject.magazines;
        this.selectedProjectId = projectId;  // Speichern der ID des ausgewählten Projekts
      }
      router.push(`/administration/${this.accordionIndex}/${projectId}`);
    },
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('page')) {
        SignalBus.emit("sidebar-reload-project_date");
      }
    },
  },
  mounted() {
    this.getProjects();
    SignalBus.connect(this,"sidebar-reload-projects", this.getProjects);
    SignalBus.connect(this,"sidebar-reload-magazine", this.getProjects);
  },
  beforeUnmount() {
     SignalBus.disconnectAllFromParent(this);
  },
  created() {
    this.projectId =  this.$route.params.projectId
    this.magazineId =  this.$route.params.magazineId
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        this.projectId = params.projectId;
        this.magazineId = params.magazineId;
      },
    }
  },
}
</script>